import { render, staticRenderFns } from "./PizzaTotalActive.vue?vue&type=template&id=b4b522de&scoped=true"
import script from "./PizzaTotalActive.vue?vue&type=script&lang=js"
export * from "./PizzaTotalActive.vue?vue&type=script&lang=js"
import style0 from "./PizzaTotalActive.vue?vue&type=style&index=0&id=b4b522de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b522de",
  null
  
)

export default component.exports